export default "__VITE_ASSET__CCMWoMvI__"